import { AppBar, Button, Dialog, DialogContent, DialogTitle, Divider, Grid, Icon, IconButton, Stack, TextField, Toolbar, Typography } from "@mui/material";
import React from "react";
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import moment from "moment";
import { useState, useEffect } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
const UtilizedView = (props) => {
    const [utilizedView, setUtilizedView] = useState(props.open);
    const [rowData, setRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([
        { field: 'giNumber', headerName: 'GI Number', minWidth: 100, },
        { field: 'initialCNTRNo', headerName: 'INTL Cntr No', minWidth: 100, },
        { field: 'giValue', headerName: 'GI Value', minWidth: 100, },
        { field: 'blDate', headerName: 'BL Date', minWidth: 100, }
    ])

    const [utilizedData, setUtilizedData] = useState({
        company: '',
        companyName: '',
        documentCreditNo: '',
        bankRefNo: '',
        docNo: '',
        totalAmount: ''
    })
    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.lcDocument}`;
    const loadUtilizedViewData = async () => {
        let letterOfCredits = props.id
        const list = await OAuthService.getList(lcUrl + `/getLcDocument?lcDocId=${letterOfCredits}`);
        if (list.data) {
            const listData = list.data.listOfOrder.map((data) => {
                data.giNumber = data.giNumber;
                data.initialCNTRNo = data.initialCNTRNo;
                data.giValue = data.giValue;
                data.blDate = data.blDate
                return data
            })
            setRowData(listData)
        }
        setUtilizedData({
            ...utilizedData,
            company: list.data.letterOfCredit.company,
            companyName: list.data.letterOfCredit.companyName,
            documentCreditNo: list.data.letterOfCredit.documentCreditNo,
            bankRefNo: list.data.bankRefNo,
            docNo: list.data.docNo,
            totalAmount: list.data.totalAmount

        })
    }
    useEffect(() => {
        loadUtilizedViewData()
    }, [])

    const handleClose = () => {
        setUtilizedView(false)
        props.handleClose()
    }

    

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            onClose={handleClose}
            open={utilizedView}
        >
            <AppBar position="static">
                <Toolbar className="flex w-full justify-between">
                    <Typography variant="subtitle1" color="inherit">
                        {props.ViewOptions === "UtilizeView" &&
                            <span>Utilized - List Of Claimed Documents</span>}
                        {props.ViewOptions === "PendingView" &&
                            <span>Pending List Of GI Submitted</span>}
                    </Typography>
                    <Button onClick={handleClose}>
                        <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                    </Button>
                </Toolbar>
            </AppBar>
            <DialogContent dividers>
                <Grid container spacing={2} className="mt-5">
                    <Grid item xs={8}>
                        <Stack>
                            <lable>Client Name</lable>
                            <TextField
                                value={utilizedData.companyName}
                                name="customer"
                                disabled
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}

                            />
                        </Stack>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            value={utilizedData.company}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}
                            style={{ marginTop: "2rem" }}

                        />
                    </Grid>
                </Grid>
                <Grid container className="mt-8" >
                    <Grid item xs={12}>
                        <Stack>
                            <lable>Documentary Credit No</lable>
                            <TextField
                                value={utilizedData.documentCreditNo}
                                // name="customer"
                                disabled
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}

                            />
                        </Stack>
                    </Grid>
                </Grid>
                <Grid container spacing={2} className="mt-8 mb-5">
                    <Grid item xs={8}>
                        <Stack>
                            <lable>Bank Ref No/Doc No </lable>
                            <TextField
                                value={utilizedData.bankRefNo}
                                name="customer"
                                disabled
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}

                            />
                        </Stack>
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                            value={utilizedData.docNo}
                            name="customer"
                            disabled
                            inputProps={{
                                sx: { 'padding': '10px' },
                            }}
                            style={{ marginTop: "2rem" }}

                        />
                    </Grid>
                </Grid>
                <Divider />
                <div className="mt-8 h-[300px]" >
                    <AgGridTable
                        rowData={rowData}
                        columnDefs={columnDefs}
                    // onGridReady={onGridReady}
                    />
                    <div className="flex justify-end items-baseline mt-8">
                        <label className="mr-8" >Total</label>
                        <TextField
                            name="total"
                            value={utilizedData.totalAmount}
                            disabled
                            inputProps={{
                                sx: { 'width': '80px', 'height': '5px' },
                            }} />
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default UtilizedView